import { PermissionRules } from '@teamworksdev/influencer/core';
import { isAgent, isBrandUser, isComplianceOfficer } from './roles';

const isServiceProvider = PermissionRules.or(
	isBrandUser,
	isAgent,
);

const accessPersonalPreferences = PermissionRules.or(
	isServiceProvider,
	isComplianceOfficer,
);

export {
	accessPersonalPreferences,
};
